import { assert } from '@ember/debug';
import { getOwnConfig } from '@embroider/macros';
import { startSpan } from '@sentry/browser';
import * as Sentry from '@sentry/browser';
import { applySdkMetadata, GLOBAL_OBJ, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE } from '@sentry/core';
function _getSentryInitConfig() {
  const _global = GLOBAL_OBJ;
  _global.__sentryEmberConfig = _global.__sentryEmberConfig ?? {};
  return _global.__sentryEmberConfig;
}

/**
 * Initialize the Sentry SDK for Ember.
 */
export function init(_runtimeConfig) {
  const environmentConfig = getOwnConfig().sentryConfig;
  assert('Missing configuration.', environmentConfig);
  assert('Missing configuration for Sentry.', environmentConfig.sentry || _runtimeConfig);
  if (!environmentConfig.sentry) {
    // If environment config is not specified but the above assertion passes, use runtime config.
    environmentConfig.sentry = {
      ..._runtimeConfig
    };
  }

  // Merge runtime config into environment config, preferring runtime.
  Object.assign(environmentConfig.sentry, _runtimeConfig || {});
  const initConfig = Object.assign({}, environmentConfig.sentry);
  applySdkMetadata(initConfig, 'ember');

  // Persist Sentry init options so they are identical when performance initializers call init again.
  const sentryInitConfig = _getSentryInitConfig();
  Object.assign(sentryInitConfig, initConfig);
  return Sentry.init(initConfig);
}
export const instrumentRoutePerformance = BaseRoute => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const instrumentFunction = async (op, name, fn, args, source) => {
    return startSpan({
      attributes: {
        [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: source,
        [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ui.ember'
      },
      op,
      name,
      onlyIfParent: true
    }, () => {
      return fn(...args);
    });
  };
  const routeName = BaseRoute.name;
  return {
    // @ts-expect-error TS2545 We do not need to redefine a constructor here
    [routeName]: class extends BaseRoute {
      beforeModel(...args) {
        return instrumentFunction('ui.ember.route.before_model', this.fullRouteName, super.beforeModel.bind(this), args, 'custom');
      }
      async model(...args) {
        return instrumentFunction('ui.ember.route.model', this.fullRouteName, super.model.bind(this), args, 'custom');
      }
      afterModel(...args) {
        return instrumentFunction('ui.ember.route.after_model', this.fullRouteName, super.afterModel.bind(this), args, 'custom');
      }
      setupController(...args) {
        return instrumentFunction('ui.ember.route.setup_controller', this.fullRouteName, super.setupController.bind(this), args, 'custom');
      }
    }
  }[routeName];
};
export * from '@sentry/browser';